import { ApiGroup } from '../types/ApiTypes';

export const InterstitialAdAPI: ApiGroup = {
    pagedList: {
        title: '전면 광고 목록 조회',
        method: 'POST',
        url: '/InterstitialAd/PagedList',
        paramz: {},
    },
    getById: {
        title: '전면 광고 조회',
        method: 'GET',
        url: '/InterstitialAd/{id}',
        paramz: {},
        pathParams: ['id'],
    },
    create: {
        title: '전면 광고 생성',
        method: 'POST',
        url: '/InterstitialAd',
        paramz: {},
    },
    update: {
        title: '전면 광고 수정',
        method: 'PUT',
        url: '/InterstitialAd/{id}',
        paramz: {},
        pathParams: ['id'],
    },
    delete: {
        title: '전면 광고 삭제',
        method: 'DELETE',
        url: '/InterstitialAd/{id}',
        paramz: {},
        pathParams: ['id'],
    },
    updateDisplayOrder: {
        title: '전면 광고 순서 변경',
        method: 'PUT',
        url: '/InterstitialAd/UpdateDisplayOrder',
        paramz: {},
    },
    clickLogsPagedList: {
        title: '클릭 로그 목록 조회',
        method: 'POST',
        url: '/InterstitialAd/ClickLogs/PagedList',
        paramz: {},
    },
    getDashboardStats: {
        title: '광고 성과 통계 대시보드 조회',
        method: 'GET',
        url: '/InterstitialAd/DashboardStats',
        paramz: {},
    },
    getDetailStats: {
        title: '광고 상세 통계 조회',
        method: 'GET',
        url: '/InterstitialAd/DetailStats',
        paramz: {},
    },
};
